module.exports = __webpack_public_path__ + "1771775a60ecc8ab9744a35a7daa36e7.MP3";